module.exports = __webpack_public_path__ + "public/img/tower00.c9247225.png";